import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";

const NAV = [
  { to: "/", label: "首页", end: true },
  { to: "/archive", label: "分类档案库", end: false },
  { to: "/#process", label: "塌房全过程", end: false },
  { to: "/#faq", label: "常见问题", end: false },
  { to: "/about", label: "关于档案库", end: false },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/80"
          : "bg-background-100"
      }`}
    >
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        {/* 顶部信息条 */}
        <div className="hidden lg:flex items-center justify-between py-2 text-xs text-foreground-600 border-b border-background-200/80">
          <p className="flex items-center gap-2">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary-500" />
            全网娱乐黑料分类检索 · 一次吃透所有瓜
          </p>
          <div className="flex items-center gap-5">
            <span className="text-foreground-500">追更不如按分类检索</span>
            <div className="flex items-center gap-3 text-foreground-500">
              <a href="#/" aria-label="微博" rel="nofollow" className="hover:text-primary-500 transition-colors"><i className="ri-weibo-line w-4 h-4 flex items-center justify-center" /></a>
              <a href="#/" aria-label="微信公众号" rel="nofollow" className="hover:text-primary-500 transition-colors"><i className="ri-wechat-line w-4 h-4 flex items-center justify-center" /></a>
              <a href="#/" aria-label="小红书" rel="nofollow" className="hover:text-primary-500 transition-colors"><i className="ri-bookmark-line w-4 h-4 flex items-center justify-center" /></a>
            </div>
          </div>
        </div>

        {/* 主导航 */}
        <div className="flex items-center justify-between py-3 md:py-4">
          <Link to="/" className="flex items-center gap-2.5" aria-label="明星黑料档案首页">
            <span className="grid place-items-center w-9 h-9 rounded-lg bg-primary-600 text-background-50">
              <i className="ri-focus-3-line text-lg" />
            </span>
            <span className="leading-none">
              <span className="block font-heading text-xl font-bold text-foreground-950 tracking-tight">
                黑料档案<span className="text-primary-600">·</span>八卦志
              </span>
              <span className="mt-1 block text-[10px] tracking-[0.2em] text-foreground-500 uppercase">Scandal Archive</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {NAV.map((n) =>
              n.to.includes("#") ? (
                <a
                  key={n.label}
                  href={n.to}
                  className="px-3.5 py-2 text-sm text-foreground-700 hover:text-primary-600 hover:bg-background-200/60 rounded-full transition-colors whitespace-nowrap"
                >
                  {n.label}
                </a>
              ) : (
                <NavLink
                  key={n.label}
                  to={n.to}
                  end={n.end}
                  className={({ isActive }) =>
                    `px-3.5 py-2 text-sm rounded-full transition-colors whitespace-nowrap ${
                      isActive
                        ? "text-primary-700 bg-primary-100 font-medium"
                        : "text-foreground-700 hover:text-primary-600 hover:bg-background-200/60"
                    }`
                  }
                >
                  {n.label}
                </NavLink>
              )
            )}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/archive"
              className="hidden sm:inline-flex items-center gap-1.5 px-3 py-2 text-sm text-foreground-600 hover:text-foreground-950 hover:bg-background-200/60 rounded-full transition-colors whitespace-nowrap"
              aria-label="搜索档案"
            >
              <i className="ri-search-line text-base" />
            </Link>
            <a
              href="/about#submit"
              className="hidden lg:inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-background-50 bg-primary-600 hover:bg-primary-700 rounded-full transition-colors whitespace-nowrap"
            >
              <i className="ri-lightbulb-flash-line text-base" />
              我要爆料
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="md:hidden grid place-items-center w-9 h-9 rounded-lg border border-background-300/70 text-foreground-800 hover:bg-background-200/70 transition-colors"
              aria-label="打开菜单"
              aria-expanded={open}
            >
              <i className={`ri-${open ? "close-line" : "menu-line"} text-lg`} />
            </button>
          </div>
        </div>
      </div>

      {/* 移动端菜单 */}
      <div
        className={`md:hidden overflow-hidden transition-[max-height] duration-300 ${open ? "max-h-96 border-t border-background-200/80 bg-background-50" : "max-h-0"}`}
      >
        <nav className="mx-auto max-w-[1200px] px-4 py-3 flex flex-col gap-1" aria-label="移动端导航">
          {NAV.map((n) => (
            <a
              key={n.label}
              href={n.to}
              onClick={() => setOpen(false)}
              className="px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-200/60 rounded-lg transition-colors"
            >
              {n.label}
            </a>
          ))}
          <a
            href="/about#submit"
            onClick={() => setOpen(false)}
            className="mt-1 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 text-sm font-medium text-background-50 bg-primary-600 hover:bg-primary-700 rounded-lg transition-colors whitespace-nowrap"
          >
            <i className="ri-lightbulb-flash-line text-base" />
            我要爆料
          </a>
        </nav>
      </div>
    </header>
  );
}